export const TRANSITION_DELAY_CLASSNAME = 'delay-200';
export const TRANSITION_DURATION_CLASSNAME = 'duration-200';
